import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-2 md:gap-2" }
const _hoisted_2 = { class: "col-span-3" }
const _hoisted_3 = { class: "bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800 mb-2" }
const _hoisted_4 = { class: "flex justify-between gap-2 mb-4" }
const _hoisted_5 = { class: "flex justify-between mb-4" }
const _hoisted_6 = { class: "flex justify-between" }
const _hoisted_7 = { class: "bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800" }
const _hoisted_8 = { class: "flex justify-between items-center mb-4" }
const _hoisted_9 = {
  style: {"position":"relative"},
  class: "col-span-9 bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6"
}
const _hoisted_10 = { class: "grid grid-cols-9 gap-5" }
const _hoisted_11 = { class: "col-span-3" }
const _hoisted_12 = { class: "col-span-3" }
const _hoisted_13 = { class: "flex justify-right gap-3 col-span-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")
  const _component_confirm_button = _resolveComponent("confirm_button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_basic_button, {
            onClick: _cache[0] || (_cache[0] = $event => ($setup.router.push('/'))),
            size: $setup.Size.large
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "fa-solid fa-home" }, null, -1 /* CACHED */),
              _createTextVNode(" Home ")
            ])),
            _: 1 /* STABLE */,
            __: [8]
          }, 8 /* PROPS */, ["size"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_basic_button, {
            onClick: _cache[1] || (_cache[1] = $event => ($setup.router.push('/reports'))),
            size: $setup.Size.large
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createElementVNode("i", { class: "fa-regular fa-file-lines" }, null, -1 /* CACHED */),
              _createTextVNode(" Reports ")
            ])),
            _: 1 /* STABLE */,
            __: [9]
          }, 8 /* PROPS */, ["size"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_basic_button, {
            onClick: _cache[2] || (_cache[2] = $event => ($setup.router.push('/settings'))),
            size: $setup.Size.large
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createElementVNode("i", { class: "fa-solid fa-gear" }, null, -1 /* CACHED */),
              _createTextVNode(" Settings ")
            ])),
            _: 1 /* STABLE */,
            __: [10]
          }, 8 /* PROPS */, ["size"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_basic_button, {
            onClick: _cache[3] || (_cache[3] = $event => ($setup.new_user())),
            size: $setup.Size.large
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createElementVNode("i", { class: "fa-solid fa-circle-plus" }, null, -1 /* CACHED */),
              _createTextVNode(" Add New User ")
            ])),
            _: 1 /* STABLE */,
            __: [11]
          }, 8 /* PROPS */, ["size"])
        ]),
        _createElementVNode("div", null, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, " Search ", -1 /* CACHED */)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.search_text) = $event)),
            placeholder: "Username or Email...",
            class: "dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, $setup.search_text]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_10, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-span-3" }, [
            _createElementVNode("strong", null, "Username")
          ], -1 /* CACHED */)),
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-span-3" }, [
            _createElementVNode("strong", null, "Email")
          ], -1 /* CACHED */)),
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "" }, null, -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.users.results, (user) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: user.id
            }, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(user.username), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_12, _toDisplayString(user.email), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createVNode(_component_basic_button, {
                  onClick: $event => ($setup.change_password(user)),
                  size: $setup.Size.small
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "fa-solid fa-key" }, null, -1 /* CACHED */),
                    _createTextVNode(" Change Password ")
                  ]))]),
                  _: 2 /* DYNAMIC */,
                  __: [13]
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "size"]), [
                  [_vShow, user.username === 'djv1']
                ]),
                _withDirectives(_createVNode(_component_basic_button, {
                  onClick: $event => ($setup.reset_password(user)),
                  size: $setup.Size.small
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("i", { class: "fa-solid fa-key" }, null, -1 /* CACHED */),
                    _createTextVNode(" Reset Password ")
                  ]))]),
                  _: 2 /* DYNAMIC */,
                  __: [14]
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "size"]), [
                  [_vShow, user.username !== 'djv1']
                ]),
                _createVNode(_component_basic_button, {
                  onClick: $event => ($setup.edit_user(user)),
                  size: $setup.Size.small
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("i", { class: "fa-solid fa-pencil" }, null, -1 /* CACHED */),
                    _createTextVNode(" Edit ")
                  ]))]),
                  _: 2 /* DYNAMIC */,
                  __: [15]
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "size"]),
                _createVNode(_component_confirm_button, {
                  onClick: $event => ($setup.del_user(user)),
                  size: $setup.Size.small
                }, {
                  confirmation_text: _withCtx(() => [
                    _createElementVNode("p", null, "Are you sure you want to delete " + _toDisplayString(user.username) + "?", 1 /* TEXT */),
                    _cache[16] || (_cache[16] = _createElementVNode("p", null, " ", -1 /* CACHED */))
                  ]),
                  default: _withCtx(() => [
                    _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fa-solid fa-trash" }, null, -1 /* CACHED */)),
                    _cache[18] || (_cache[18] = _createTextVNode(" Delete "))
                  ]),
                  _: 2 /* DYNAMIC */,
                  __: [17,18]
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "size"])
              ])
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createCommentVNode(" <div v-show=\"user.is_editing\"  class=\"grid grid-cols-9 gap-4\">\n                    <div class=\"col-span-4\">{{ user.Username }}</div>\n                    <div class=\"col-span-4\">{{ user.Email }}</div>\n                    <div class=\"flex justify-between gap-3\">\n                        <basic_button @click=\"save_user(user)\"\n                            :size=\"Size.small\"\n                        >\n                            <i class=\"fa-solid fa-save\"></i>\n                        </basic_button>\n                        <basic_button @click=\"cancel_edit(user)\"\n                            :size=\"Size.small\"\n                        >\n                            <i class=\"fa-solid fa-circle-xmark\"></i>\n                        </basic_button>\n                    </div>\n                </div> ")
      ]),
      _createVNode($setup["Paginator"], {
        "total-items": $setup.users?.total_count,
        "current-page": $setup.current_page,
        "page-size": $setup.page_size,
        "onUpdate:pageSize": _cache[5] || (_cache[5] = $event => ($setup.page_size = $event)),
        "onUpdate:currentPage": _cache[6] || (_cache[6] = $event => ($setup.current_page = $event))
      }, null, 8 /* PROPS */, ["total-items", "current-page", "page-size"]),
      _createVNode($setup["EditUser"], {
        open: $setup.dat_open_edit_user,
        user: $setup.dat_selected_user,
        onFinished: _cache[7] || (_cache[7] = $event => ($setup.dat_reset = !$setup.dat_reset))
      }, null, 8 /* PROPS */, ["open", "user"]),
      _createVNode($setup["ChangePassword"], {
        open: $setup.dat_open_change_password,
        user: $setup.dat_selected_user
      }, null, 8 /* PROPS */, ["open", "user"]),
      _createVNode($setup["CreateRegistrationToken"], {
        open: $setup.dat_open_create_registration_token,
        user_id: $setup.dat_selected_user?.id
      }, null, 8 /* PROPS */, ["open", "user_id"])
    ])
  ]))
}